import { ICutBoxFull } from "./types";
import { ISelection } from "logic/src/objects/chat/types";

function getTextNode(element: Element) {
  let result = null;
  element.childNodes.forEach(function (node) {
    if (node.nodeType === Node.TEXT_NODE) {
      result = node;
    }
  });
  return result;
}

export const selectText = (selectInfo: ISelection) => {
  const textElement1 = document.querySelector(
    `[data-item-id="${selectInfo.startId}"]`,
  );
  const textElement2 = document.querySelector(
    `[data-item-id="${selectInfo.endId}"]`,
  );

  if (textElement1 && textElement2) {
    const range = document.createRange();
    // range.selectNodeContents(textElement);
    range.setStart(getTextNode(textElement1)!, selectInfo.startOffset);
    range.setEnd(getTextNode(textElement2)!, selectInfo.endOffset);

    const selection = window.getSelection();
    selection?.removeAllRanges(); // 清除之前的所有选区
    selection?.addRange(range); // 添加新的选区
  }
};

export const gotoSelection = (selectInfo: ISelection) => {
  const textElement1 = document.querySelector(
    `[data-item-id="${selectInfo.startId}"]`,
  );
  // textElement1?.scrollIntoView(true);
  textElement1?.scrollIntoView({
    behavior: "smooth",
    block: "nearest",
    inline: "nearest",
  });
};

export const getCanvasInfoByPoint = (
  x: number,
  y: number,
): {
  node: HTMLCanvasElement;
  pageNumber: number | null;
} | null => {
  const element = document.elementsFromPoint(x, y);
  for (let i = 0; i < element.length; i++) {
    if (element[i].nodeName === "CANVAS") {
      // @ts-ignore
      const pageNumber = element[i + 1].dataset.pageNumber;
      return {
        node: element[i] as HTMLCanvasElement,
        pageNumber: pageNumber ? Number(pageNumber) : null,
      };
    }
  }
  return null;
};

export const getCanvasRatio = (node: HTMLCanvasElement): number => {
  const ctxWidth = node.width;
  const nodeRects = node.getClientRects();
  const width = nodeRects[0]?.width || ctxWidth;

  return ctxWidth / width;
};

export const getCanvasInfoByPageNumber = (
  num: number,
): {
  node: HTMLCanvasElement;
  pageNumber: number | null;
} | null => {
  const element = document.querySelector(
    `div[data-page-number="${num}"] canvas`,
  );
  if (element) {
    return {
      node: element as HTMLCanvasElement,
      pageNumber: num,
    };
  }
  return null;
};

const getPointAtCanvas = (x: number, y: number, canvas: HTMLCanvasElement) => {
  const rect = canvas.getClientRects();
  return [x - rect[0].x, y - rect[0].y];
};

const getHeightToEnd = (y: number, canvas: HTMLCanvasElement) => {
  const rect = canvas.getClientRects();
  return rect[0].y + rect[0].height - y;
};

const getHeightToStart = (y: number, canvas: HTMLCanvasElement) => {
  const rect = canvas.getClientRects();
  return y - rect[0].y;
};

export const cutImg = (v: ICutBoxFull, cb: (v: File) => void) => {
  const startCanvas = getCanvasInfoByPoint(v.x, v.y);
  const endCanvas = getCanvasInfoByPoint(v.endX, v.endY);
  if (
    !startCanvas ||
    !endCanvas ||
    startCanvas.pageNumber === null ||
    endCanvas.pageNumber === null
  )
    return;
  const tempCanvas = document.createElement("canvas");
  tempCanvas.width = v.width;
  tempCanvas.height = v.height;
  const ctx = tempCanvas.getContext("2d");
  const ratio = getCanvasRatio(startCanvas.node);
  if (startCanvas.pageNumber === endCanvas.pageNumber) {
    const [x, y] = getPointAtCanvas(v.x, v.y, startCanvas.node);
    ctx?.drawImage(
      startCanvas.node,
      x * ratio,
      y * ratio,
      v.width * ratio,
      v.height * ratio,
      0,
      0,
      v.width,
      v.height,
    );
  } else {
    const [x, y] = getPointAtCanvas(v.x, v.y, startCanvas.node);
    const height = getHeightToEnd(v.y, startCanvas.node);
    ctx?.drawImage(
      startCanvas.node,
      x * ratio,
      y * ratio,
      v.width * ratio,
      height * ratio,
      0,
      0,
      v.width,
      height,
    );

    if (endCanvas.pageNumber - startCanvas.pageNumber > 1) {
      let currentY = height;
      for (let j = startCanvas.pageNumber + 1; j < endCanvas.pageNumber; j++) {
        const currentCanvas = getCanvasInfoByPageNumber(j);

        if (currentCanvas) {
          const currentRect = currentCanvas?.node.getClientRects();
          const currentHeight = currentRect[0].height;
          ctx?.drawImage(
            currentCanvas.node,
            x * ratio,
            0,
            v.width * ratio,
            currentHeight * ratio,
            0,
            currentY,
            v.width,
            currentHeight,
          );

          currentY = currentY + currentHeight;
        }
      }
    }

    const [endX] = getPointAtCanvas(v.endX, v.endY, endCanvas.node);
    const lastheight = getHeightToStart(v.endY, endCanvas.node);
    ctx?.drawImage(
      endCanvas.node,
      (endX - v.width) * ratio,
      0,
      v.width * ratio,
      lastheight * ratio,
      0,
      v.height - lastheight,
      v.width,
      lastheight,
    );
  }

  tempCanvas.toBlob((blob: Blob | null) => {
    if (blob) {
      const file = new File([blob], "canvas_image.png", { type: "image/png" });
      if (ClipboardItem) {
        const clipboardItem = new ClipboardItem({
          [file.type]: file,
        });
        navigator.clipboard.write([clipboardItem]);
      }
      cb(file);
    }
  });
};

function removeAllChildren(element: HTMLElement) {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

export function getTextWithoutChildren(element: Element) {
  let text = "";
  for (let node of element.childNodes) {
    if (node.nodeType === Node.TEXT_NODE) {
      text += node.textContent;
    }
  }
  return text.trim(); // 去除前后的空白字符
}

export function highlightSpanPosition(
  container: HTMLElement,
  start: number,
  end: number,
  highlightContainer: HTMLElement,
) {
  const allContent = getTextWithoutChildren(container);

  if (container.style.fontFamily) {
    highlightContainer.style.fontFamily = container.style.fontFamily;
  }
  const startText = allContent.slice(0, start);
  const highlightContent = allContent.slice(start, end);
  const endText = allContent.slice(end);
  const startTextNode = document.createTextNode(startText);
  const endTextNode = document.createTextNode(endText);
  const highlightTextNode = document.createTextNode(highlightContent);
  const highNode = document.createElement("span");
  highNode.className = `cus-highlight`;
  highNode.append(highlightTextNode);
  highlightContainer.append(startTextNode);
  highlightContainer.append(highNode);
  highlightContainer.append(endTextNode);
  container.append(highlightContainer);
}

export function highlightSpan(
  container: HTMLElement,
  type: "start" | "end" | "all",
  offset: number,
  highlightContainer: HTMLElement,
) {
  const allContent = getTextWithoutChildren(container);

  if (container.style.fontFamily) {
    highlightContainer.style.fontFamily = container.style.fontFamily;
  }
  if (type === "start") {
    const text = allContent.slice(0, offset);
    const highlightContent = allContent.slice(offset);
    const textNode = document.createTextNode(text);
    const highlightTextNode = document.createTextNode(highlightContent);
    const highNode = document.createElement("span");
    highNode.className = `cus-highlight`;
    highNode.append(highlightTextNode);

    highlightContainer.append(textNode);
    highlightContainer.append(highNode);
  } else if (type === "end") {
    const highlightContent = allContent.slice(0, offset);
    const text = allContent.slice(offset);
    const textNode = document.createTextNode(text);
    const highlightTextNode = document.createTextNode(highlightContent);
    const highNode = document.createElement("span");
    highNode.className = `cus-highlight`;
    highNode.append(highlightTextNode);
    highlightContainer.append(highNode);
    highlightContainer.append(textNode);
  } else {
    const highlightTextNode = document.createTextNode(allContent);
    const highNode = document.createElement("span");
    highNode.className = `cus-highlight`;
    highNode.append(highlightTextNode);
    highlightContainer.classList.add("highlight-content");
    highlightContainer.append(highNode);
  }

  container.append(highlightContainer);
}

export function highlightSelectedNode(selectInfo: ISelection) {
  const textElement1 = document.querySelector(
    `[data-item-id="${selectInfo.startId}"]`,
  );
  const textElement2 = document.querySelector(
    `[data-item-id="${selectInfo.endId}"]`,
  );

  if (!textElement1 || !textElement2) return null;

  const range = document.createRange();
  range.setStart(getTextNode(textElement1)!, selectInfo.startOffset);
  range.setEnd(getTextNode(textElement2)!, selectInfo.endOffset);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);

  let commonAncestor = range.commonAncestorContainer;

  if (commonAncestor.nodeType !== Node.ELEMENT_NODE) {
    commonAncestor = commonAncestor.parentElement!;
  }

  const walker = document.createTreeWalker(
    commonAncestor,
    NodeFilter.SHOW_ELEMENT,
    {
      acceptNode(node: Node): number {
        // @ts-ignore
        const rightClass = node.classList.contains("custom-text");
        if (selection?.containsNode(node, true)) {
          if (rightClass) {
            return NodeFilter.FILTER_ACCEPT;
          } else {
            return NodeFilter.FILTER_SKIP;
          }
        }
        return NodeFilter.FILTER_REJECT;
      },
    },
  );

  const selectedNodes: HTMLElement[] = [];
  let currentNode: Node | null = walker.nextNode();

  while (currentNode) {
    selectedNodes.push(currentNode as HTMLElement);
    currentNode = walker.nextNode();
  }

  if (
    (commonAncestor as HTMLElement).classList.contains("custom-text") &&
    selectedNodes.length === 0
  ) {
    const highlightContainer = document.createElement("span");
    highlightContainer.className = `highlight-container`;
    highlightContainer.dataset.selectionId = selectInfo.id;
    return highlightSpanPosition(
      commonAncestor as HTMLElement,
      selectInfo.startOffset,
      selectInfo.endOffset,
      highlightContainer,
    );
  }

  selectedNodes.forEach(div => {
    const highlightContainer = document.createElement("span");
    highlightContainer.className = `highlight-container`;
    highlightContainer.dataset.selectionId = selectInfo.id;
    if (div.dataset.itemId === selectInfo.startId) {
      highlightSpan(div, "start", selectInfo.startOffset, highlightContainer);
    } else if (div.dataset.itemId === selectInfo.endId) {
      highlightSpan(div, "end", selectInfo.endOffset, highlightContainer);
    } else {
      highlightSpan(div, "all", 0, highlightContainer);
    }
  });

  selection?.removeAllRanges();
}

export function highlightSelectedNodes(selectInfoList: ISelection[]) {
  const allHighLight = document.querySelectorAll(
    ".custom-text .highlight-container",
  );
  allHighLight.forEach(node => {
    const parent = node.parentElement;
    parent?.removeChild(node);
  });
  selectInfoList.forEach(highlightSelectedNode);
}
